import template from './bargain-conditions.jade';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.bargainConditions', [])
    .directive('cianAfPriceAndDealTermsBargainConditions', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            if (!this.ad.bargainTerms) {
                this.ad.bargainTerms = {};
            }

            this.validation = validation(this.form, 'bargainTerms.bargainConditions', {
                maxlength: 'Превышено ограничение',
            });
        },
        controllerAs: 'bargainConditions',
        template,
    }))
    .name;
